module.exports = __webpack_public_path__ + "static/media/lucienPlongeon.4d2f74ae.png";